import {SearchResultRecord} from './search-result-record.model';
import {AutocompleteRecommendationDomInjector} from '../autocomplete-recommendation/autocomplete-recommendation-dom-injector';
import {BehaviorSubject} from 'rxjs';

export class AutocompleteNode  {
    index: number;
    recommendation: SearchResultRecord;
    domInjector: AutocompleteRecommendationDomInjector;
    nodesFocusStream: BehaviorSubject<AutocompleteNode>;
}